export default __webpack_public_path__ + "static/media/trade4.4e00efe0.png";